export const DPCExtraListColumn = (navigate, options = {}) => [
  {
    title: "Discount components",
    dataIndex: "discountComponents",
    key: "discountComponents",
  },
  {
    title: "Status",
    dataIndex: "status",
    key: "status",
    render: (key) => {
      return (
        <div className={key === "ACTIVE" ? "activted" : "inactive"}>{key}</div>
      );
    },
  },

  {
    title: "Action",
    render: (key) => {
      if (!options.showManage && !options.showView) {
        return null;
      }

      return (
        <div className="action-icons">
          <div>
            {options.showManage && (
              <button
                className="manage"
                onClick={() => navigate("/edit-dpc-extra", { state: key })}
              >
                Manage
              </button>
            )}
            {options.showView && (
              <button
                className="manage"
                onClick={() => navigate("/edit-dpc-extra", { state: key })}
              >
                View
              </button>
            )}
          </div>
        </div>
      );
    },
  },
];
